import { Button } from "@salt-ds/core";

function ErrorPage(props: any) {
  return (
    <div className={"error-page"}>
      <div className={"oops"}>Oops!</div>
      <div className={"message"}>Something went wrong...</div>
      {props.resetErrorBoundary && (
        <div>
          <Button className={"retry-button"} onClick={props.resetErrorBoundary}>
            🔄 Try Again!
          </Button>
        </div>
      )}
    </div>
  );
}

export default ErrorPage;
